import { createLazyReactDirective } from '../shell/createLazyReactDirective';

createLazyReactDirective(
  async () => (await import('./FloorPlanMarkupEditor')).FloorPlanMarkupEditor,
  'floorPlanMarkupEditor',
  {
    imageId: '=',
    imageUrl: '=',
    sectionId: '=',
    boundFloors: '=',
    onFloorsChange: '&',
  },
);
